import { HubConnection, HubConnectionState } from '@microsoft/signalr';

export const DEFAULT_HUB_CONNECTION = {
  state: HubConnectionState.Disconnected,
  on: () => {},
  off: () => {},
  invoke: () => {},
} as unknown as HubConnection; // just to match HubConnection
